import React from 'react';

import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
function DropdownSelect({ items, selectedItem, handleItemChange, label }) {

  const labelId = `${label.replace(/\s+/g, '-').toLowerCase()}-dropdown-label`;

  return (
    <FormControl variant="outlined" style={{ minWidth: 200 }}>
      <InputLabel id={labelId}>{label}</InputLabel>
      <Select
        labelId={labelId}
        value={selectedItem}
        onChange={handleItemChange}
        label={label}
      >
        {items.map((item) => (
          <MenuItem key={item.id} value={item.id}>
            {item.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default DropdownSelect;